module.exports = __webpack_public_path__ + "img/Shale-Headshot.png";